var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect } from "react";
import ResizeObserverPolyfill from "resize-observer-polyfill";
/**
 * @private
 */
var isRefTarget = function (target) {
    return !!target &&
        typeof target.current !==
            "undefined";
};
/**
 * @private
 */
var isFunctionTarget = function (target) {
    return typeof target === "function";
};
/**
 * A utility function to get the current resize observer element.
 *
 * @private
 */
export function getResizeObserverTarget(target) {
    if (isRefTarget(target)) {
        return target.current;
    }
    if (isFunctionTarget(target)) {
        return target();
    }
    if (typeof target === "string") {
        return document.querySelector(target);
    }
    return target;
}
/**
 *
 * @private
 */
export function isHeightChange(prevSize, nextSize) {
    return (!prevSize ||
        prevSize.height !== nextSize.height ||
        prevSize.scrollHeight !== nextSize.scrollHeight);
}
/**
 *
 * @private
 */
export function isWidthChange(prevSize, nextSize) {
    return (!prevSize ||
        prevSize.width !== nextSize.width ||
        prevSize.scrollWidth !== nextSize.scrollWidth);
}
/**
 * A hook that is used to trigger esize events when a target element is resized
 * via CSS or other changes.
 *
 * @param options The resize observer options.
 */
export default function useResizeObserver(_a) {
    var _b = _a.disableHeight, disableHeight = _b === void 0 ? false : _b, _c = _a.disableWidth, disableWidth = _c === void 0 ? false : _c, onResize = _a.onResize, target = _a.target;
    useEffect(function () {
        if (disableHeight && disableWidth) {
            return;
        }
        var resizeTarget = getResizeObserverTarget(target);
        if (!resizeTarget) {
            return;
        }
        var prevSize;
        var observer = new ResizeObserverPolyfill(function (entries) {
            for (var i = 0; i < entries.length; i += 1) {
                var entry = entries[i];
                var target_1 = entry.target;
                var _a = entry.contentRect, height = _a.height, width = _a.width;
                var scrollHeight = target_1.scrollHeight, scrollWidth = target_1.scrollWidth;
                var nextSize = {
                    height: height,
                    width: width,
                    scrollHeight: scrollHeight,
                    scrollWidth: scrollWidth,
                };
                var isNewHeight = isHeightChange(prevSize, nextSize);
                var isNewWidth = isWidthChange(prevSize, nextSize);
                prevSize = nextSize;
                if ((isNewHeight && !disableHeight) || (isNewWidth && !disableWidth)) {
                    onResize(__assign(__assign({}, nextSize), { element: target_1 }));
                }
            }
        });
        observer.observe(resizeTarget);
        return function () {
            observer.disconnect();
        };
    }, [target, onResize, disableHeight, disableWidth]);
}
//# sourceMappingURL=useResizeObserver.js.map